export { default as yn } from "yn";
export type { Options as YnOptions } from "yn";
